// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jlQE","placeholdersHeader":"styles_placeholdersHeader__1z7kG","editorStyle":"styles_editorStyle__3tQ4y","placeholdersBox":"styles_placeholdersBox__2oakv"};